import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CodeAssignmentSegment  {
    _originalTypeClassName = "zERP.BO.CodeAssignmentSegment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CodeAssignmentSegment.translate = translateService;
}
this.Options = [];
this.Id = null;
this.Length = null;
this.Type = null;
this.NextNumber = null;
this.HardCodedValue = null;
this.TrailingCharacter = null;
this.UserValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Length:any;
Type:any;
NextNumber:any;
HardCodedValue:any;
TrailingCharacter:any;
UserValue:any;
Options:any;
static setOptions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Options == null) $this.Options = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Options.length > 0) {
                    Domain.CodeAssignmentSegment.removeOptions($this, $this.Options[0]);
                }

                Domain.CodeAssignmentSegment.addManyOptions($this, copyItems);
            }
static addManyOptions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CodeAssignmentSegment.addOptions($this, items[i]);
                }
            }
static addOptions = ($this, item) => {
                if ($this.Options == null) $this.Options = [];
                if (item == null || $this.Options.indexOf(item) > -1) return;
                $this.Options.push(item);
}
static addRangeOptions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CodeAssignmentSegment.addOptions($this, item));
            }
static removeOptions = ($this, item) => {
                if ($this == null || $this.Options == null || $this.Options.indexOf(item) === -1) return;
                var _index = $this.Options.indexOf(item);
                $this.Options.splice(_index, 1);
}
static clearOptions = ($this) => { $this.Options = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}